import { Component, inject, OnInit } from '@angular/core';
import { Api } from '../../services/api';
import { MatDialog } from '@angular/material/dialog';
import { MdlEventsInfo } from '../outlook/mdl-events-info/mdl-events-info';
import { MdlSendMail } from '../outlook/mdl-send-mail/mdl-send-mail';

@Component({
  selector: 'app-home',
  imports: [],
  templateUrl: './home.html',
  styleUrl: './home.css'
})
export class Home implements OnInit {

  public events: any = [];
  public api = inject(Api);

  readonly dialog = inject(MatDialog);

  constructor() { }

  ngOnInit(): void {
    this.api.getOutlookEvents().subscribe({
      next: (data: any) => {
        this.events = data.data;
        console.log(this.events);
      },
      error: (err) => {
        console.error('Error fetching Outlook events:', err);
      }
    });
  }

  connectOutlook() {
    const tenantId = "7eafb56d-40c8-4934-842a-c9207647bbe0";
    const clientId = "6b59dcd9-2f94-41f7-adbd-6a4050cf015c";
    const redirectUri = "http://localhost:3000/api/auth/callback"; // backend
    const scopes = [
      "openid",
      "profile",
      "offline_access",
      "User.Read",
      "Mail.Send",
      "Calendars.Read"
    ];

    // Tu JWT local (ejemplo: guardado en localStorage después del login en tu app)
    const jwtLocal = localStorage.getItem("crmtoken");

    // Armamos la URL
    const authUrl =
      `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize` +
      `?client_id=${clientId}` +
      `&response_type=code` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&response_mode=query` +
      `&scope=${encodeURIComponent(scopes.join(" "))}` +
      `&state=${encodeURIComponent(jwtLocal ?? '')}`;

    // Redirigir al usuario
    window.location.href = authUrl;
  }

  openEventDetails() {
    this.dialog.open(MdlEventsInfo, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        events: this.events
      }
    });
  }

  openMailModal() {
    this.dialog.open(MdlSendMail, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        events: this.events
      }
    });
  }

}
